<template>
  <layout :title="$helper.testTitle" :sub-title="$test.fullLabel">
    <template slot="right-column">
      <help-button />
    </template>
    <template slot="container">
      <template v-if="!isLoading">
        <div v-if="!showTest" class="bg-primary text-white text-center p-4 text-uppercase">
          <strong>{{ $t('finished.test_finished') }}</strong>
        </div>
        <template v-if="$helper.isPlayerPrepa">
          <template v-if="showTest">
            <test-content
              :test-info="testInfo"
              :previous-question="previousQuestion"
              :previous-question-module-label="previousQuestionModuleLabel"
              show-answer
              :correction="correction"
              :clear-fill="clearFill"
            />
            <b-row class="layout-footer">
              <b-col offset-sm="9" sm="3">
                <b-btn
                  variant="primary"
                  class="h-100"
                  block
                  @click="getNextQuestion"
                >{{ $t(`finished.actions.${testInfo.total === currentQuestionIndex ? 'go_back_results' : 'next_question'}`) }}</b-btn>
              </b-col>
            </b-row>
          </template>
          <div v-else class="preparation-results">
            <b-container>
              <b-row class="mt-4">
                <b-col cols="6">
                  <b-btn
                    variant="outline-primary"
                    block
                    @click="showAllAnswers"
                  >{{ $t('finished.actions.show_all_answers') }}</b-btn>
                </b-col>
                <b-col cols="6">
                  <b-btn
                    :disabled="_.isEmpty(explainAnswers)"
                    variant="outline-primary"
                    block
                    @click="showExplainAnswers"
                  >{{ $t('finished.actions.show_explain_answers') }}</b-btn>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="6">
                  <b-btn
                    :disabled="_.isEmpty(errorAnswers)"
                    variant="outline-primary"
                    block
                    @click="showErrorAnswers"
                  >{{ $t('finished.actions.show_error_answers') }}</b-btn>
                </b-col>
                <b-col cols="6">
                  <form
                    v-loading="`<i class='ti ti-refresh ti-spin'></i>`"
                    @submit.prevent="onQuitTestSubmit"
                  >
                    <b-btn
                      type="submit"
                      variant="outline-primary"
                      block
                    >{{ $t('finished.close_test') }}</b-btn>
                  </form>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </template>
        <template v-else>
          <template v-if="results">
            <div class="results-container text-center">
              <h2>{{ $t('finished.title') }}</h2>
              <h3>{{ $t('finished.result') }} :</h3>
              <div class="result-number">{{ results.score.toFixed() }} %</div>
              <div class="mb-3">
                <strong>{{ $t('finished.nb_answers', { correct: results.nbCorrectAnswers, questions: results.nbQuestions }) }}</strong>
              </div>

              <!-- florian -->
              <!-- 26-28/08 ajout d'un bouton de partage sur les reseaux fcbk twttr lnkdn viadeo -->
              <div>
                <b-button pill size="lg" v-b-modal="'modal-rs'" >
                  Partager sur les réseaux !
                  <!-- composant share bind pour recuperer les données et les inserer dans le post sur les reseaux
                  / attention a translation fr/en
                  / modal ne se ferme pas-->


                </b-button>
              </div>
              <hr />
              <!-- florian -->
              <share
                      :testLabel="$test.fullLabel"
                      :examId="$test.data.exam_id"
                      :score="results.score.toFixed()"
              />
              <b-card class="w-75 mx-auto pt-2 pb-2">
                <b-row>
                  <b-col xl="6">
                    <h4>{{ $t('finished.answers_by_category') }} :</h4>
                  </b-col>
                  <b-col xl="6" class="d-none d-xl-block">
                    <h4>{{ $t('finished.answers_by_level') }} :</h4>
                  </b-col>
                </b-row>
                <b-row align-v="center">
                  <b-col xl="6">
                    <template v-for="(answer, index) in results.resultSyllabus">
                      <progress-label
                        :key="index"
                        :label="answer.label"
                        :progress="answer.valid * 100 / answer.total"
                      />
                    </template>
                  </b-col>
                  <b-col class="d-xl-none mt-2">
                    <h4>{{ $t('finished.answers_by_level') }} :</h4>
                  </b-col>
                  <b-col xl="6">
                    <template v-for="(answer, index) in results.resultDifficulty">
                      <progress-label
                        :key="index"
                        :label="answer.label"
                        :progress="answer.valid * 100 / answer.total"
                      />
                    </template>
                  </b-col>
                </b-row>
              </b-card>
              <b-container v-if="$helper.isPlayerDemo36" class="mt-4" fluid>
                <b-row>
                  <b-col offset-sm="4" sm="4">
                    <form
                      v-loading="`<i class='ti ti-refresh ti-spin'></i>`"
                      @submit.prevent="onDownloadPdfSubmit"
                    >
                      <b-btn type="submit" variant="primary" block>{{ $t('finished.download_pdf') }}</b-btn>
                    </form>
                  </b-col>
                </b-row>
              </b-container>
              <b-container v-if="$helper.isPlayerDemo12" class="mt-4" fluid>
                <b-row>
                  <b-col offset-sm="2" sm="4">
                    <a
                      href="https://www.icdl.quebec/se-former-a-la-certification-icdl/"
                      target="_blank"
                      class="btn btn-primary btn-block"
                    >{{ $t('finished.private') }}</a>
                  </b-col>
                  <b-col sm="4">
                    <b-btn v-b-modal.professionalFormModal block>{{ $t('finished.professional') }}</b-btn>
                    <b-modal id="professionalFormModal" hide-footer>
                      <form
                        v-loading="`<i class='ti ti-refresh ti-spin'></i>`"
                        class="text-left"
                        @submit.prevent="onProfessionalFormSubmit"
                      >
                        <vue-form-generator
                          :schema="professionalSchema"
                          :model="professionalModel"
                          :options="{ validationAfterLoad: true, validationAfterChanged: true }"
                        />
                        <b-btn type="submit" variant="primary" block>{{ $t('actions.send') }}</b-btn>
                      </form>
                    </b-modal>
                  </b-col>
                </b-row>
              </b-container>
            </div>
          </template>
          <template v-else>
            <div class="p-4 text-center">
              <p>{{ $t('finished.hide_test') }}</p>
              <form
                v-loading="`<i class='ti ti-refresh ti-spin'></i>`"
                @submit.prevent="onGetResultSubmit"
              >
                <b-button type="submit">{{ $t('finished.refresh_results') }}</b-button>
              </form>
            </div>
          </template>
        </template>
        <b-row v-if="!$helper.isPlayerPrepa" class="footer-finish">
          <b-col offset-sm="4" sm="4">
            <b-button v-if="$test.url != undefined && $test.url.length" :href="$test.url" block>{{ $t('finished.close_test') }}</b-button>
            <b-button v-else :to="{name : 'logout'}" block>{{ $t('finished.close_test') }}</b-button>
          </b-col>
        </b-row>
      </template>
      <loader-text v-else :title="$t('finished.is_loading')" />
    </template>
  </layout>
</template>


<script>
import Layout from "@/views/Layout";
import TestContent from "@/components/test-content";
import LoaderText from "@/components/loader-text";
import ProgressLabel from "@/components/progress-label";
import HelpButton from "@/components/help-button";
import LoadOnNavigate from "@/mixins/load-on-navigate";
import VueFormGenerator from "@triotech/vue-core/src/vendor/vue-form-generator";
import Share from "@/components/share"; //import du composant share

export default {
  name: "ResultView",
  components: {
    Layout,
    TestContent,
    LoaderText,
    ProgressLabel,
    HelpButton,
    Share, //export du composant share
    "vue-form-generator": VueFormGenerator.component,
  },
  mixins: [LoadOnNavigate],
  data() {
    return {
      results: null,
      currentTest: [],
      errorAnswers: [],
      explainAnswers: [],
      testInfo: {},
      previousQuestion: {},
      previousQuestionModuleLabel: null,
      correction: {},
      clearFill: false,
      showTest: false,
      isLoading: true,
      currentQuestionIndex: 0,
      professionalModel: {
        last_name: null,
        first_name: null,
        email: null,
        job: null,
        company: null,
        phone_number: null,
      },
      professionalSchema: {
        fields: [
          {
            type: "input",
            id: "last_name",
            inputType: "text",
            label: this.$t("form.last_name"),
            model: "last_name",
            placeholder: this.$t("form.last_name"),
            required: true,
          },
          {
            type: "input",
            id: "first_name",
            inputType: "text",
            label: this.$t("form.first_name"),
            model: "first_name",
            placeholder: this.$t("form.first_name"),
            required: true,
          },
          {
            type: "input",
            id: "email",
            inputType: "email",
            label: this.$t("form.email"),
            model: "email",
            placeholder: this.$t("form.email"),
            required: true,
          },
          {
            type: "input",
            id: "job",
            inputType: "text",
            label: this.$t("form.job"),
            model: "job",
            placeholder: this.$t("form.job"),
            required: true,
          },
          {
            type: "input",
            id: "company",
            inputType: "text",
            label: this.$t("form.company"),
            model: "company",
            placeholder: this.$t("form.company"),
            required: true,
          },
          {
            type: "input",
            id: "phone_number",
            inputType: "text",
            label: this.$t("form.phone_number"),
            model: "phone_number",
            placeholder: this.$t("form.phone_number"),
            required: true,
          },
        ],
      },
    };
  },

  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      this.$root.$children[0].setFullScreen();
    })
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      this.$root.$children[0].setFullScreen();
    });
  },
  methods: {
    async load() {
      await this.onGetResultSubmit();
    },

    closeModal() {
      this.$bvModal.hide("modal-rs");
    },
    onProfessionalFormSubmit() {
      return this.$ajax
        .post("public/demo12/email", this.professionalModel)
        .then(() => {
          this.$notify({
            text: this.$t("flashes.professional.success"),
            type: "success",
          });
          this.$root.$emit("bv::hide::modal", "professionalFormModal");
        })
        .catch(() => {
          this.$notify({
            text: this.$t("flashes.professional.error"),
            type: "error",
          });
        });
    },
    onGetResultSubmit() {
      this.isLoading = true;
      return this.$test.finishedTest().then((data) => {
        this.results = data;
        if (this.$helper.isPlayerPrepa) {
          this.errorAnswers = this._.filter(
            data,
            (datum) => !datum.answer.valid
          );
          this.explainAnswers = this._.filter(
            data,
            (datum) => datum.question.explaination
          );
        }

        this.isLoading = false;
      });
    },
    showAllAnswers() {
      this.currentTest = this.results;
      this.getNextQuestion();
    },
    showErrorAnswers() {
      this.currentTest = this.errorAnswers;
      this.getNextQuestion();
    },
    showExplainAnswers() {
      this.currentTest = this.explainAnswers;
      this.getNextQuestion();
    },
    onDownloadPdfSubmit() {
      return this.$test.pdf();
    },
    onQuitTestSubmit() {
      return this.$test.quitTest();
    },
    getNextQuestion() {
      if (!this.showTest) {
        this.showTest = true;
        this.testInfo.total = this.currentTest.length;
      }

      const data = this.currentTest[this.currentQuestionIndex];

      if (!data) {
        this.showTest = false;
        this.currentQuestionIndex = 0;
      } else {
        this.$set(this.testInfo, "question_number", data.question.number);
        this.previousQuestionModuleLabel = data.question.module_localised_label;
        this.previousQuestion = data.question;
        this.correction = data.answer;
        this.clearFill = true;

        this.currentQuestionIndex += 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/vars";

h2 {
  font-size: 2rem !important;
  padding: 30px;
}

h3 {
  color: $grey !important;
  font-size: 1rem !important;
}

h4 {
  color: $black !important;
  font-size: 1rem !important;
}

.results-container {
  padding-bottom: 120px;
}

.footer-finish {
  background-color: darken($grey, 30);
  padding: 20px 0;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  .btn {
    background-color: transparent;
    border: 2px solid $white;
    color: $white;
    border-radius: 30px !important;
    text-transform: uppercase;

    &:hover {
      background-color: darken($grey, 10);
      border: 2px solid $white;
    }
  }
}

.result-number {
  font-weight: bold;
  font-size: 2.5rem;
  padding: 20px;
}

.preparation-results {
  .btn {
    height: 200px;
  }
}
</style>
